/** Client-side check for an application URL; the API's appUrlSchema has the final say. */
export const urlProblem = (v: string) => {
  if (!v) return null;
  try {
    return ['http:', 'https:'].includes(new URL(v).protocol) ? null : 'Use an http:// or https:// address.';
  } catch {
    return 'Enter a full address, for example https://myshop.com';
  }
};
